<template>
<Page title="Kontakta oss" image="contact.jpg">
    <b-container class="contact">
        <div class="contact-form md-surface">
            <h2 class="md-section-title mt-0">Hör av dig</h2>
            <p class="md-text-2">
                Är du intresserad av att veta mer om oss eller de tjänster vi erbjuder?
                Fyll i formuläret nedan så kontaktar vi dig så snart som möjligt!
            </p>
            <p class="md-text-2 contact-direct">
                Du kan också mejla oss direkt på
                <a href="mailto:ritningar.se@outlook.com">ritningar.se@outlook.com</a>.
            </p>
            <b-alert v-if="sent" variant="success" show>
                Tack för ditt meddelande! Vi återkommer så snart vi kan.
            </b-alert>
            <b-form v-else @submit.prevent="send">
                <b-form-group label="Namn" label-for="contact-name">
                    <b-input id="contact-name" type="text" placeholder="Ditt namn" v-model="name" required maxlength="100" />
                </b-form-group>
                <b-form-group label="E-post" label-for="contact-email">
                    <b-input id="contact-email" type="email" placeholder="Din e-postadress" v-model="email" required maxlength="200" />
                </b-form-group>
                <b-form-group label="Meddelande" label-for="contact-message">
                    <b-form-textarea id="contact-message" v-model="message" placeholder="Ditt meddelande..." rows="4" max-rows="6" required maxlength="5000"></b-form-textarea>
                </b-form-group>
                <!-- people never see it: a bot fills it in -->
                <input v-model="website" class="contact-website" type="text" name="website" tabindex="-1" autocomplete="off" aria-hidden="true" />
                <b-alert v-if="error" variant="danger" show>{{ error }}</b-alert>
                <div class="text-right">
                    <b-button type="submit" variant="primary" size="lg" :disabled="sending">
                        <b-spinner v-if="sending" small class="mr-2"></b-spinner>Skicka
                    </b-button>
                </div>
            </b-form>
        </div>
    </b-container>
</Page>
</template>

<script>
import axios from "axios";
const Page = () => import("@/components/page/Page");

// what contact.php answers, in words
const ERRORS = {
    invalid: "Kontrollera namn, e-postadress och meddelande.",
    limit: "Du har skickat många meddelanden på kort tid. Försök igen om en stund.",
};
const ERROR_OTHER = "Meddelandet kunde inte skickas. Försök igen, eller mejla oss på ritningar.se@outlook.com.";

export default {
    name: 'Contact',
    components: {
        Page
    },
    data() {
        return {
            name: "",
            email: "",
            message: "",
            website: "",
            sending: false,
            sent: false,
            error: null
        };
    },
    methods: {
        async send() {
            this.sending = true;
            this.error = null;
            try {
                await axios.post("/api/contact.php", {
                    name: this.name,
                    email: this.email,
                    message: this.message,
                    website: this.website
                });
                this.sent = true;
            } catch (e) {
                const code = e.response && e.response.data && e.response.data.error;
                this.error = ERRORS[code] || ERROR_OTHER;
            } finally {
                this.sending = false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
.contact {
    max-width: 720px;
}

.contact-form {
    margin-top: 24px;
    padding: 28px;
}

.contact-direct a {
    font-weight: 700;
    overflow-wrap: anywhere;
}

.contact-website {
    position: absolute;
    left: -10000px;
    width: 1px;
    height: 1px;
    opacity: 0;
}

::v-deep label {
    font-weight: 700;
    color: var(--md-text);
}

@media (max-width: 575px) {
    .contact-form {
        padding: 20px;
    }
}
</style>
